var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": "Cetak Mutasi Aset",
      "id": "print-modal",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": !_vm.isValidForm
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.submit($event);
            }
          }
        }, [_vm._v("Cetak")])];
      },
      proxy: true
    }])
  }, [_c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Tanggal Awal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.form.tgl_awal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tgl_awal", $$v);
      },
      expression: "form.tgl_awal"
    }
  })], 1), _c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Tanggal Akhir"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.form.tgl_akhir,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tgl_akhir", $$v);
      },
      expression: "form.tgl_akhir"
    }
  })], 1), _vm.myGudang ? _c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Asal Mutasi"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "value": _vm.myGudang.nama_gudang
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Tujuan Mutasi"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.gudangOptions,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text"
    },
    model: {
      value: _vm.form.id_gudang_tujuan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_gudang_tujuan", $$v);
      },
      expression: "form.id_gudang_tujuan"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }